<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false" custom-class="maxss" width="1500px" :top="dialogTop"
    :before-close="handleClose" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-text="正在保存中" style="overflow: hidden">
    <div class="whole" ref="whole" @click="handleClickEvt">
      <div style="width: 360px; margin-left: 10px; position: fixed">
        <div class="cloneEvt">
          <span @click="saveEvt" :style="{
            background: asd == true ? '#3383EA' : '#979797',
          }">保存</span>
          <span @click="deleteEvt">删除</span>
        </div>
        <div style="width: 360px">
          <div style="
              height: 180px;
              border: 1px solid #d9d9d9;
              border-radius: 5px;
              background: #fff;
              margin-top: 7px;
            ">
            <el-form ref="form" :model="sizeForm" label-width="48px" size="mini">
              <el-form-item label="开工时间" style="
                  margin-top: 20px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                ">
                <el-date-picker :disabled="userRole == 4 || userRole == 8" v-model="value3"
                  style="width: 280px; margin-left: 6px" type="date" @change="openEvt(1)" size="mini"
                  format="yyyy-MM-dd" range-separator="" class="border_box" placeholder="开工时间" align="right"
                  value-format="timestamp">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="项目名称" style="
                  margin-top: 10px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                ">
                <el-input :disabled="userRole == 4 || userRole == 8" v-model="name" placeholder="请填写（必须填）"
                  @focus="asd = true"></el-input>
              </el-form-item>

              <el-form-item label="客户信息" style="
                  margin-top: 10px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                " v-if="userRole !== 4 && userRole != 8">
                <el-input v-model="value_1" placeholder="" disabled></el-input>
              </el-form-item>
              <div class="stateE">
                <div v-bind:class="{ active: activeIndex_box === 1 }" @click="setActive(1)">
                  进行中
                </div>
                <div v-bind:class="{ active: activeIndex_box === 2 }" @click="setActive(2)">
                  暂停
                </div>
                <div v-bind:class="{ active: activeIndex_box === 3 }" @click="setActive(3)">
                  完工
                </div>
              </div>
            </el-form>
          </div>
          <div class="Completion_status">
            <el-form ref="form" :model="sizeForm" label-width="48px" size="mini">
              <el-form-item label="实际完工" style="
                  margin-top: 20px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                ">
                <el-date-picker v-model="value1" style="width: 280px; margin-left: 6px" type="date" size="mini"
                  format="yyyy-MM-dd" range-separator="" class="border_box" placeholder="实际完工" align="right"
                  value-format="timestamp" @change="openEvt()">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="要求完工" style="font-size: 12px; padding: 0px 10px 0px 10px">
                <el-date-picker v-model="value2" style="width: 280px; margin-left: 6px" type="date" size="mini"
                  format="yyyy-MM-dd" range-separator="" class="border_box" placeholder="要求完工" align="right"
                  value-format="timestamp" @change="openEvt()">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="客户名称" class="name_oe" style="
                  margin-top: 20px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                " v-if="userRole != 4 && userRole != 5 && userRole != 8">
                <el-select class="name_oe" v-model="customer" filterable placeholder="请选择" @change="openEvt_one()">
                  <el-option v-for="(item, index) in customer_box" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同金额" style="font-size: 12px; padding: 0px 10px 0px 10px"
                v-if="userRole != 4 && userRole != 5 && userRole != 8">
                <el-row>
                  <el-col :span="12">
                    <el-input v-model="contract_amount" placeholder="请选择" @input="checkInput" class="maxs">
                    </el-input>
                  </el-col>
                  <el-col :span="12" style="width: 100px !important">
                    <el-select v-model="currency" placeholder="人民币" class="mins" @change="openEvt()">
                      <el-option v-for="(item, index) in currency_box" :key="index" :label="item.name" :value="item.id"
                        placeholder="人民币">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item label="客户维护" style="
                  margin-top: 20px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                " v-if="userRole != 5 && userRole != 8">
                <el-select v-model="assistant_id" filterable placeholder="请选择" @change="openEvt()" disabled>
                  <el-option v-for="(item, index) in customer_box" :key="index" :label="item.staff_name"
                    :value="item.assistant_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="市场签单" style="font-size: 12px; padding: 0px 10px 0px 10px"
                v-if="userRole != 5 && userRole != 8">
                <el-select v-model="set_of" filterable placeholder="请选择" @change="openEvt()" :disabled="userRole == 4">
                  <el-option v-for="(item, index) in set_of_box" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目负责" style="
                  margin-top: 10px;
                  font-size: 12px;
                  padding: 0px 10px 0px 10px;
                " v-if="userRole != 8">
                <el-select v-model="charge" filterable placeholder="请选择" @change="openEvt()">
                  <el-option v-for="(item, index) in charge_box" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="
              height: 300px;
              margin-top: 10px;
              border: 1px solid #d9d9d9;
              border-radius: 5px;
              background: #fff;
            ">
            <el-form ref="form" :model="sizeForm" label-width="48px" size="mini">
              <div style="display: flex; margin-top: 10px">
                <div style="
                    display: flex;
                    flex-direction: column;
                    width: 60px;
                    font-size: 12px;
                  ">
                  <span style="margin-left: 8px">制作内容</span>
                  <span style="
                      margin-top: 20px;
                      cursor: pointer;
                      color: #9b9a9a;
                      margin-left: -12px;
                    " @click="remarkEvt(1)">历史</span>
                </div>
                <div>
                  <textarea class="text_box" v-model="content_remark" @click="cleEvt"></textarea>
                </div>
              </div>
              <div style="display: flex; margin-top: 10px">
                <div style="
                    display: flex;
                    flex-direction: column;
                    width: 60px;
                    font-size: 12px;
                  ">
                  <span style="margin-left: 8px">项目进度</span>
                  <span style="
                      margin-top: 5px;
                      cursor: pointer;
                      color: #9b9a9a;
                      margin-left: -12px;
                    " @click="remarkEvt(2)">历史</span>
                </div>
                <div>
                  <textarea class="text_box" v-model="progress_remark" @click="cleEvt"></textarea>
                </div>
              </div>
              <div style="display: flex; margin-top: 10px" v-if="userRole != 4 && userRole != 5 && userRole != 8">
                <div style="
                    display: flex;
                    flex-direction: column;
                    width: 60px;
                    font-size: 12px;
                  ">
                  <span style="margin-left: 8px">回款进度</span>
                  <span style="
                      margin-top: 5px;
                      cursor: pointer;
                      color: #9b9a9a;
                      margin-left: -12px;
                    " @click="remarkEvt(3)">历史</span>
                </div>
                <div>
                  <textarea class="text_box" v-model="refund_remark" @click="cleEvt"></textarea>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div class="banner" id="container" ref="banner">
        <div class="offside">
          <div class="tabs">
            <span @click="showTab('tab1')" :class="{ active: activeTab === 'tab1' }" ref="tab1">图量安排</span>

            <span @click="showTab('tab2')" :class="{ active: activeTab === 'tab2' }" ref="tab2"
              v-if="userRole != 4 && userRole != 5 && userRole != 8">回款明细</span>

            <span @click="showTab('tab5')" :class="{ active: activeTab === 'tab5' }" ref="tab5"
              v-if="userRole != 4 && userRole != 5 && userRole != 8">合同管理</span>

            <span @click="showTab('tab6')" :class="{ active: activeTab === 'tab6' }" ref="tab6"
              v-if="userRole != 4 && userRole != 5 && userRole != 8">结算单</span>

            <span @click="showTab('tab3')" :class="{ active: activeTab === 'tab3' }" ref="tab3"
              style="width: 68px">成图</span>

            <span @click="showTab('tab4')" :class="{ active: activeTab === 'tab4' }" ref="tab4" v-if="
              userRole != 3 && userRole != 4 && userRole != 5 && userRole != 8
            ">成本统计</span>
          </div>
        </div>
        <div class="arrangement" ref="arrangement" id="tab1Content" v-if="activeTab == 'tab1' ? true : false">
          <div class="amount_to" style="border-radius: 5px">
            <div style="
                width: 465px;
                display: flex;
                justify-content: start;
                margin-left: 47px;
              ">
              合计
            </div>
            <!-- //规划 -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="type_plan" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_plan == 0 ? '#f00' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="type_plan" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_plan == 0 ? '#d1d1d1' : '#f00' }" />

              <input v-if="tableDate.length > 0" type="text" v-model="type_plan" class="amount" placeholder="0"
                @input="calculateTotal" :style="{ color: textColor3 }" />
              <!-- :style="{ color: type_plan == 0 ? '#d1d1d1' : (comparePlan == true ? '#000' : '#f00') }" -->
            </div>
            <!-- 鸟瞰 -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="type_birdview" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_birdview == 0 ? ' #f00 ' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="type_birdview" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_birdview == 0 ? '#d1d1d1' : '#f00' }" />

              <input v-if="tableDate.length > 0" type="text" v-model="type_birdview" class="amount" placeholder="0"
                @input="calculateTotal" :style="{ color: textColor2 }" />
              <!-- :style="{ color: type_birdview == 0 ? '#d1d1d1' : (compareBirdview == true ? '#000' : '#f00') }" -->
            </div>
            <!-- 透视 -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="type_perspective" class="amount"
                placeholder="0" @input="calculateTotal"
                :style="{ color: type_perspective == 0 ? ' #f00 ' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="type_perspective" class="amount"
                placeholder="0" @input="calculateTotal"
                :style="{ color: type_perspective == 0 ? '#d1d1d1' : '#f00' }" />
              <input v-if="tableDate.length > 0" type="text" v-model="type_perspective" class="amount" placeholder="0"
                @input="calculateTotal" :style="{ color: textColor1 }" />
              <!-- :style="{ color: type_perspective == 0 ? '#d1d1d1' : (comparePerspective == true ? '#000' : '#f00') }" -->
            </div>
            <!-- 室内 -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="type_indoor" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_indoor == 0 ? ' #f00 ' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="type_indoor" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_indoor == 0 ? '#d1d1d1' : '#f00' }" />

              <input v-if="tableDate.length > 0" type="text" v-model="type_indoor" class="amount" placeholder="0"
                @input="calculateTotal" :style="{ color: textColor }" />
              <!-- :style="{ color: (type_indoor == 0 ? '#d1d1d1' : (compareIndoor == true ? '#000' : '#f00')) }" -->
            </div>
            <!-- vr -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="type_vr" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_vr == 0 ? ' #f00 ' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="type_vr" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_vr == 0 ? '#d1d1d1' : '#f00' }" />

              <input v-if="tableDate.length > 0" type="text" v-model="type_vr" class="amount" placeholder="0"
                @input="calculateTotal" :style="{ color: textColor4 }" />

              <!-- :style="{ color: type_vr == 0 ? '#d1d1d1' : (compareVR == true ? '#000' : '#f00') }" -->
            </div>
            <!-- 动画 -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="type_animation" class="amount"
                placeholder="0" @input="calculateTotal"
                :style="{ color: b || amountEvt == 0 ? ' #f00 ' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="type_animation" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: type_animation == 0 ? '#d1d1d1' : '#f00' }" />

              <input v-if="tableDate.length > 0" type="text" v-model="type_animation" class="amount" placeholder="0"
                @input="calculateTotal" :style="{ color: textColor6 }" />
              <!-- :style="{ color: type_animation == 0 ? '#d1d1d1' : (b || amountEvt == 0) ? '#000' : '#f00' }" -->
            </div>
            <!-- 总图 -->
            <div>
              <input type="text" v-if="tableDate.length == 0 && isAllZero" v-model="amountEvt" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: a || amountEvt == 0 ? '#f00' : '#d1d1d1' }" />

              <input type="text" v-if="tableDate.length == 0 && !isAllZero" v-model="amountEvt" class="amount"
                placeholder="0" @input="calculateTotal" :style="{ color: amountEvt == 0 ? '#d1d1d1' : '#f00' }" />

              <input v-if="tableDate.length > 0" type="text" v-model="amountEvt" class="amount" placeholder="0"
                readonly="true" :style="{ color: textColor5 }" />
              <!-- :style="{ color: (amountEvt == 0 || a ) ? '#000' : '#f00' }" -->
            </div>

            <div>
              <img @click="addRow" src="../images/Component 1.png" alt="" style="cursor: pointer; margin-left: 10px" />
            </div>
          </div>
          <el-table ref="tableData" :data="tableDate" style="width: 100%" height="100%" class="my-table"
            autofocus="true">
            <el-table-column prop="date" align="left">
              <template slot-scope="scope">
                <el-select class="signEvt" v-model="scope.row.group_id" @change="xiugai" filterable placeholder="请选择" clearable>
                  <el-option v-for="(item, index) in group_box" :key="index" :label="item.name" :value="item.id"
                    :disabled="selectedValues.includes(item.id)" ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="type_plan" label="规划" width="70" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.type_plan" class="niaokan" @input="amountTotal(scope.row)"
                  @keydown.native="nextFocus($event, scope.$index, scope.row)"
                  :class="{ 'gray-text': parseInt(scope.row.type_plan) === 0 }"></el-input>
              </template>
            </el-table-column>

            <el-table-column prop="type_birdview" label="鸟瞰" width="70" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.type_birdview" class="niaokan" @input="amountTotal(scope.row)"
                  @keydown.native="nextFocus($event, scope.$index, scope.row)" :class="{
                    'gray-text': parseInt(scope.row.type_birdview) === 0,
                  }"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type_perspective" label="透视" width="70" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.type_perspective" class="niaokan"
                  @input="amountTotal(scope.row)" @keydown.native="nextFocus($event, scope.$index, scope.row)" :class="{
                    'gray-text': parseInt(scope.row.type_perspective) === 0,
                  }"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type_indoor" label="室内" width="70" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.type_indoor" class="niaokan" @input="amountTotal(scope.row)"
                  @keydown.native="nextFocus($event, scope.$index, scope.row)" :class="{
                    'gray-text': parseInt(scope.row.type_indoor) === 0,
                  }"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type_vr" label="VR" width="70" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.type_vr" class="niaokan" @input="amountTotal(scope.row)"
                  @keydown.native="nextFocus($event, scope.$index, scope.row)"
                  :class="{ 'gray-text': parseInt(scope.row.type_vr) === 0 }"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type_animation" label="动画（秒）" width="70" align="center" class-name="pad_e">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.type_animation" class="niaokan" @input="amountTotal(scope.row)"
                  @keydown.native="nextFocus($event, scope.$index, scope.row)" :class="{
                    'gray-text': parseInt(scope.row.type_animation) === 0,
                  }"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="zip" label="总图量" width="70" align="center">
              <template slot-scope="scope">
                <input type="text" v-model="scope.row.type_total" class="niaokan" readonly
                  :class="{ 'gray-text': parseInt(scope.row.type_total) === 0 }" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center" style="width: 55px; outline: none; height: 33px">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.$index)" type="text" size="small">
                  <img src="../images/reduce.png" alt="" style="width: 15px; height: 15px" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="Payment" ref="Payment" id="tab2Content" v-if="activeTab == 'tab2' ? true : false">
          <div style="
              margin-top: 30px;
              justify-content: space-between;
              display: flex;
              border-bottom: 1px solid #d9d9d9;
            ">
            <span style="margin-left: 20px; margin-bottom: 5px">
              是否完成回款 <span v-html="is_success"></span></span>
            <span style="margin-right: 30px; margin-bottom: 5px">回款周期：{{ backed_days }}天</span>
          </div>
          <el-table :data="backedinfoDtata" style="width: 100%; height: 130px" @cell-click="idEvt"
            @cell-mouse-enter="huaguo">
            <el-table-column prop="" label="" width="10"> </el-table-column>
            <el-table-column prop="id" label="回款编号" width="80">
            </el-table-column>
            <el-table-column prop="income_time" label="回款日期" width="100">
            </el-table-column>
            <el-table-column prop="amount" label="回款金额" width="80">
            </el-table-column>
            <el-table-column prop="currency_name" label="币种" width="80">
            </el-table-column>
            <el-table-column prop="backed_money" label="指认金额" width="80">
            </el-table-column>
            <el-table-column prop="exchange" label="当时汇率" width="80">
            </el-table-column>
            <el-table-column prop="conversion" label="当时折算" align="right" width="100">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="kanEvt(2)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 32px" class="Mapping_quantity" ref="Mapping_quantity" id="tab3Content"
          v-if="activeTab == 'tab3' ? true : false">
       
          <div class="image-container" style="margin-top: 40px;">
                 <span class="min_one" @click="uploadVisible = true">上传图片</span>
            <div v-for="(image, index) in images" :key="index" class="mapping" style="position: relative">
                <img :src="image.thumb" alt="Image" @click.stop="imgEvt(image)" />
                <div class="select" :style="{
                  display: image.select == true ? 'block' : 'none',
                  position: 'absolute',
                }">
                  <i class="el-icon-check"></i>
                </div>
                <span style="
                    font-size: 11px;
                    width: 100%;
                    text-align: right;
                    cursor: pointer;
                    margin-top: 15px;
                  " @click="deleteImage()" class="clones">删除</span>
                <div style="
                    display: flex;
                    justify-content: space-between;
                    height: 30px;
                    line-height: 0px;
                    font-size: 11px;
                  ">
                  <p>{{ image.staff }}</p>
                  <p>{{ image.score }}</p>
                </div>
              </div>
          </div>
        </div>
        <div class="max4" ref="max4" style="
            height: 800px;
            background: #fff;
            margin-top: 32px;
            border-radius: 5px;
          " id="tab4Content" v-if="activeTab == 'tab4' ? true : false"></div>

        <div class="max5" ref="max5" style="
            height: 840px;
            background: #fff;
            margin-top: 32px;
            border-radius: 5px;
            position: relative;
          " id="tab5Content" v-if="activeTab == 'tab5' ? true : false">
          <div style="
              display: flex;
              width: 100%;
              height: 40px;
              align-items: center;
              justify-content: space-between;
              padding: 0 10px;
            ">
            <div>
              <span class="upload-btn" @click="triggerFileInput()">上传</span>
              <span class="upload-btn" @click="deleteFile(currentPdf, currentVersionIndex)">删除</span>
              <span>{{ currentPdf ? currentPdf.create_time : "" }}</span>
            </div>
            <div style="display: flex; align-items: center">
              <img src="@/images/left.png" alt="prev" style="width: 14px; height: 18px; cursor: pointer"
                @click="prevVersion" :style="{ opacity: currentVersionIndex === 0 ? 0.3 : 1 }" />
              <span style="margin: 0 10px">当前版本</span>
              <img src="@/images/right.png" alt="next" style="width: 14px; height: 18px; cursor: pointer"
                @click="nextVersion('contract')" :style="{
                  opacity: currentVersionIndex >= pdfList.length - 1 ? 0.3 : 1,
                }" />
            </div>
          </div>

          <div style="height: 800px; cursor: pointer" class="shangchuan">
            <input type="file" accept=".pdf" @change="onFileSelect($event)" :ref="'fileInput'" style="display: none" />
            <div v-if="currentPdf" style="height: 100%">
              <iframe :src="currentPdf.url + '#view=FitH'" width="100%" height="100%" style="border: none"></iframe>
            </div>
            <div v-show="!currentPdf" @click="triggerFileInput()" @drop="handleDrop($event)"
              @dragover.prevent="() => { }" @paste="handlePaste($event)" @mouseenter="onMouseEnter"
              @mouseleave="onMouseLeave" style="
                position: absolute;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
                background-color: transparent;
              ">
              <img class="img_e" src="@/images/111.png" alt="Upload" style="
                  width: 40px;
                  height: 40px;
                  margin-bottom: 10px;
                  margin-top: 400px;
                " />
              <p>点击或拖拽上传</p>
            </div>
          </div>
        </div>
        <div class="max6" ref="max6" style="
            height: 840px;
            background: #fff;
            margin-top: 32px;
            border-radius: 5px;
            position: relative;
          " id="tab6Content" v-if="activeTab == 'tab6' ? true : false">
          <div style="
              display: flex;
              width: 100%;
              height: 40px;
              align-items: center;
              justify-content: space-between;
              padding: 0 10px;
            ">
            <div>
              <span class="upload-btn" @click="triggerFileInput('settlement')">上传结算单</span>
              <span class="upload-btn" @click="deleteFile(currentSettlementPdf, 'settlement')">删除</span>
              <span>{{
                currentSettlementPdf ? currentSettlementPdf.create_time : ""
              }}</span>
            </div>
            <div style="display: flex; align-items: center">
              <img src="@/images/left.png" alt="prev" style="width: 14px; height: 18px; cursor: pointer"
                @click="prevVersion('settlement')" :style="{ opacity: settlementVersionIndex === 0 ? 0.3 : 1 }" />
              <span style="margin: 0 10px">当前版本</span>
              <img src="@/images/right.png" alt="next" style="width: 14px; height: 18px; cursor: pointer"
                @click="nextVersion('settlement')" :style="{
                  opacity:
                    settlementVersionIndex >= settlementPdfList.length - 1
                      ? 0.3
                      : 1,
                }" />
            </div>
          </div>
          <div style="height: 800px; cursor: pointer" class="shangchuan">
            <input type="file" accept=".pdf" @change="onFileSelect($event, 'settlement')" :ref="'settlementFileInput'"
              style="display: none" />
            <div v-if="currentSettlementPdf" style="height: 100%">
              <iframe :src="currentSettlementPdf.url + '#view=FitH'" width="100%" height="100%"
                style="border: none"></iframe>
            </div>
            <div v-show="!currentSettlementPdf" @click="triggerFileInput('settlement')"
              @drop="handleDrop($event, 'settlement')" @dragover.prevent="() => { }"
              @paste="handlePaste($event, 'settlement')" @mouseenter="onMouseEnter('settlement')"
              @mouseleave="onMouseLeave('settlement')" style="
                position: absolute;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
                background-color: transparent;
              ">
              <img class="img_e" src="@/images/111.png" alt="Upload" style="
                  width: 40px;
                  height: 40px;
                  margin-bottom: 10px;
                  margin-top: 400px;
                " />
              <p>点击或拖拽上传结算单（PDF）</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="上传参考" :visible.sync="uploadVisible" width="90%" :close-on-press-escape="true"
      :destroy-on-close="true" append-to-body>
      <Upload :id="id" />
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <el-dialog :title="getTitleText()" :visible.sync="dialogTableVisible" append-to-body>
      <el-table :data="DateData" border>
        <el-table-column property="username" label="填写人" width="150">
          <template slot-scope="props">
            <el-input v-model="props.row.username" class="Add_list" readonly></el-input>
          </template>
        </el-table-column>
        <el-table-column property="create_time" label="创建时间" width="200">
          <template slot-scope="props">
            <el-input v-model="props.row.create_time" class="Add_list" readonly></el-input>
          </template>
        </el-table-column>
        <el-table-column property="remark" label="备注">
          <template slot-scope="props">
            <el-input v-model="props.row.remark" class="Add_list"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" @click="handleAdd" style="margin-top: 10px">新增</el-button>
      <el-button type="primary" @click="submitFun" style="margin-top: 10px">保存</el-button>
    </el-dialog>

    <el-dialog :visible.sync="searchLabelDialog" width="1100px" :top="dialogTop" append-to-body
      custom-class="searchLabel" :show-close="false" @close="clearValues">
      <div style="width: 100%; height: 800px; background: #a7a7a7">
        <div class="image-container_one">
          <button class="prev-button" @click="prevImage"></button>
          <div v-for="(e, index) in infoArr" :key="index" v-show="index === currentIndex">
            <img :src="e.url" style="height: 800px; width: 100%; object-fit: contain" @click="reduce" />
            <div>
              <span>{{ e.project_name }}</span>
              <span>{{ e.staff }}</span>
            </div>
          </div>
          <button class="next-button" @click="nextImage"></button>
        </div>
      </div>
    </el-dialog>
    <Imcole ref="childComponentRef" />
  </el-dialog>
</template>


<script>
import {
  EditApi,
  DropdownApi,
  DelApi,
  RemarklistApi,
  AddApi,
  DeleApi,
  InfoTwoApi,
  IncomeApi,
  CloneApi,
  UploadContractApi,
  UploadctApi,
  InfoApi,
} from "../api/home/home.js";
import Upload from "@/components/Upload.vue";
import Imcole from "@/components/imcole.vue";

export default {
  components: {
    Upload,
    Imcole,
  },

  props: {
    dialogFormVisible: Boolean,
  },
  data() {
    return {
      activeTab: "tab1",
      activeIndex_box: 1, // 默认选中第一个 项目状态
      colors: {
        1: "white", // 颜色映射表
        2: "green",
      },
      sizeForm: null,
      dialogVisible: false,
      value: "",
      tableData: [],
      DateData: [],
      images: [],
      selectedValue: null,
      start_time: null,
      name: null,
      sign: null,
      set_of: null,
      charge: null,
      assistant_id: null,
      value_1: null,
      group: null,
      customer: null,
      currency: 4,

      sign_box: null,
      set_of_box: null,
      charge_box: null,
      assistant_id_box: null,
      group_box: null,
      customer_box: null,
      currency_box: 4,
      content_remark: null,
      progress_remark: null,
      refund_remark: null,
      type_plan: null,
      type_birdview: null,
      type_perspective: null,
      type_indoor: null,
      type_vr: null,
      type_animation: null,
      value1: "",
      value2: "",
      value3: "",
      contract_amount: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(
                current.valueOf() - (nowDayOfWeek - 1) * dayNum
              );
              const lastDate = new Date(
                new Date(firstDate).valueOf() + 6 * dayNum
              );
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(
                new Date().getTime() - 60 * 60 * 24 * 7 * 1000
              );
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() -
                nowDayOfWeek +
                (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      saveData: [],
      dataList: [],
      clickTriggered: false, // 获取页面是否被点击
      showError: false, //判断输入的是否为数字
      amountEvt: "", //合计
      total_box: null,
      total_one: null,
      loading: false,
      resData: null,
      tableDate: [],
      id: null,

      is_success: null,
      backed_days: null,

      backedinfoDtata: [],
      uploadVisible: false,
      xms: true,

      backendValue: "", // 后端返回的值
      asd: false, //确认上面的值是否有被修改
      areEqual1: true,
      areEqual2: true,
      areEqual3: true,
      areEqual4: true,
      areEqual: true,
      selectedValues: [], // 存储已选择的选项的id
      dialogTableVisible: false,
      type: null,
      //已选中图片数据
      selectArr: [],
      searchLabelDialog: false,
      currentIndex: 0,
      infoArr: [],
      selectedId: null,
      resData_one: null,

      dialogTop: null, // 初始值为1vh
      userRole: null, //权限字段
      comparePlan: null,
      compareBirdview: null,
      compareIndoor: null,
      comparePerspective: null,
      compareVR: null,
      a: false,
      b: false,

      isAllZero: false,
      Pdf: [],

      currentVersionIndex: 0, // 当前版本索引
      versions: [
        { name: "之前版本", content: "这是版本 1 的内容" },
        { name: "现在版本", content: "这是版本 2 的内容" },
      ],
      isDragging: false,

      settlementPdf: [], // 结算单PDF列表（对应合同的Pdf）
      settlementVersionIndex: 0, // 结算单当前版本索引（对应合同的currentVersionIndex）
      settlementSignKey: "", // 结算单OSS签名Key（对应合同的SignKey）
    };
  },
  created() {
    DropdownApi({}).then((res) => {
      this.set_of_box = res.data.sign;
      this.assistant_id_box = res.data.assistant;
      this.charge_box = res.data.charge;
      this.group_box = res.data.group;
      this.customer_box = res.data.customer;
      this.currency_box = res.data.currency;
    });
    //1游客 2财务 3市场 4项目经理(助理) 5制作组长 6超级管理 7主管
    this.userRole = localStorage.getItem("role");
    //每次进入清空之前的内容
    this.clearContent();
    window.addEventListener("keydown", this.handKeyCode, false);
  },
  mounted() {
    this.userRole = localStorage.getItem("role");
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    const container = this.$el;

    // 监听整个容器的 dragenter 和 leave
    container.addEventListener("dragenter", this.handleDragEnter);
    container.addEventListener("dragleave", this.handleDragLeave);

    // 清理
    this.$once("hook:beforeDestroy", () => {
      container.removeEventListener("dragenter", this.handleDragEnter);
      container.removeEventListener("dragleave", this.handleDragLeave);
    });
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("keydown", this.handKeyCode, false);
    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    pdfList() {
      return this.Pdf.slice().sort(
        (a, b) => new Date(b.create_time) - new Date(a.create_time)
      );
    },
    // 当前选中的 PDF
    currentPdf() {
      return this.Pdf[this.currentVersionIndex] || null;
    },

    // ---- 新增结算单计算属性 ----
    settlementPdfList() {
      // 结算单列表按创建时间倒序（同合同逻辑）
      // return this.settlementPdf.slice().sort((a, b) => new Date(b.create_time) - new Date(a.create_time));

      return this.settlementPdf
        .slice()
        .sort((a, b) => new Date(b.create_time) - new Date(a.create_time));
    },
    currentSettlementPdf() {
      // 当前选中的结算单（同合同逻辑）
      // return this.settlementPdf[this.settlementVersionIndex] || null;
      return this.settlementPdf[this.settlementVersionIndex] || null;
    },

    // ---------------- 各列小组求和 ----------------
    sumPlanFromTable() {
      return this.tableDate.reduce(
        (acc, item) => acc + parseFloat(item.type_plan || 0),
        0
      );
    },
    sumBirdviewFromTable() {
      return this.tableDate.reduce(
        (acc, item) => acc + parseFloat(item.type_birdview || 0),
        0
      );
    },
    sumPerspectiveFromTable() {
      return this.tableDate.reduce(
        (acc, item) => acc + parseFloat(item.type_perspective || 0),
        0
      );
    },
    sumIndoorFromTable() {
      return this.tableDate.reduce(
        (acc, item) => acc + parseFloat(item.type_indoor || 0),
        0
      );
    },
    sumVRFromTable() {
      return this.tableDate.reduce(
        (acc, item) => acc + parseFloat(item.type_vr || 0),
        0
      );
    },

    sumTotalFromTable() {
      return this.tableDate.reduce((acc, item) => {
        return (
          acc +
          parseFloat(item.type_plan || 0) +
          parseFloat(item.type_birdview || 0) +
          parseFloat(item.type_perspective || 0) +
          parseFloat(item.type_indoor || 0) +
          parseFloat(item.type_vr || 0)
        );
      }, 0);
    },

    // ---------------- 各列颜色判断 ----------------
    textColor3() {
      // 规划
      const equal =
        Math.abs(this.sumPlanFromTable - parseFloat(this.type_plan || 0)) <
        0.001;
      return equal ? "#000" : "#f00";
    },
    textColor2() {
      // 鸟瞰
      const equal =
        Math.abs(
          this.sumBirdviewFromTable - parseFloat(this.type_birdview || 0)
        ) < 0.001;
      return equal ? "#000" : "#f00";
    },
    textColor1() {
      // 透视
      const equal =
        Math.abs(
          this.sumPerspectiveFromTable - parseFloat(this.type_perspective || 0)
        ) < 0.001;
      return equal ? "#000" : "#f00";
    },
    textColor() {
      // 室内
      const equal =
        Math.abs(this.sumIndoorFromTable - parseFloat(this.type_indoor || 0)) <
        0.001;
      return equal ? "#000" : "#f00";
    },
    textColor4() {
      // VR
      const equal =
        Math.abs(this.sumVRFromTable - parseFloat(this.type_vr || 0)) < 0.001;
      return equal ? "#000" : "#f00";
    },
    textColor6() {
      return this.type_animation ? "#000" : "#f00";
    },

    // ---------------- 总图量颜色判断 ----------------
    sumFromProject() {
      return (
        parseFloat(this.project.type_plan || 0) +
        parseFloat(this.project.type_birdview || 0) +
        parseFloat(this.project.type_perspective || 0) +
        parseFloat(this.project.type_indoor || 0) +
        parseFloat(this.project.type_vr || 0)
      );
    },
    isTotalEqual() {
      const equal =
        Math.abs(this.sumTotalFromTable - parseFloat(this.amountEvt || 0)) <
        0.001;
      console.log(
        "小组总和:",
        this.sumTotalFromTable,
        "amountEvt:",
        this.amountEvt,
        "相等:",
        equal
      );
      return equal;
    },
    textColor5() {
      // 总图量
      return this.isTotalEqual ? "#000" : "#f00";
    },
  },
  methods: {
    onMouseEnter() {
      // 鼠标进入：绑定全局粘贴事件
      document.addEventListener("paste", this.handlePaste);
    },

    onMouseLeave() {
      // 鼠标离开：解绑全局粘贴事件
      document.removeEventListener("paste", this.handlePaste);
    },

    handlePaste(event, type = "contract") {
      event.preventDefault();
      event.stopPropagation();
      const items = event.clipboardData.items;
      if (!items) return;

      let file = null;
      // 1. 从剪贴板获取PDF文件（逻辑与原代码一致，无修改）
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file") {
          const blob = item.getAsFile();
          const isPdfByType = blob.type === "application/pdf";
          const isPdfByName = blob.name.toLowerCase().endsWith(".pdf");
          if (isPdfByType || isPdfByName) {
            file = blob;
            break;
          }
        }
      }

      // 2. 校验文件（复用原有validateFile方法，无修改）
      if (!file) {
        this.$message.info(
          `仅支持粘贴 ${type === "contract" ? "合同" : "结算单"
          } PDF 文件（请从文件管理器复制 PDF 后粘贴）`
        );
        return;
      }
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        return;
      }

      // 3. 执行上传（传入类型，区分合同/结算单）
      this.simulateUploadSuccess(file, null, type);
    },
    handleDragEnter(event) {
      if (event.dataTransfer.types.includes("Files")) {
        this.isDragging = true;
      }
    },
    handleDragLeave(event) {
      // 简单处理：离开容器就关闭
      this.isDragging = false;
    },
    // 处理拖拽上传
    handleDrop(event, type = "contract") {
      event.preventDefault();
      event.stopPropagation();
      const files = event.dataTransfer.files;

      // 新增：限制单次仅上传1个文件（修复原有bug）
      if (files.length > 1) {
        this.$message.warning(
          `仅支持单次拖拽上传1个${type === "contract" ? "合同" : "结算单"
          }PDF文件`
        );
        return;
      }
      if (files.length === 0) return;

      const file = files[0];
      // 校验文件（复用）
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        return;
      }

      // 执行上传（传入类型）
      this.simulateUploadSuccess(file, null, type);
    },

    // 点击“上传合同”时触发文件选择
    triggerFileInput(type = "contract") {
      // 根据类型获取对应的文件输入框ref：合同用'fileInput'，结算单用'settlementFileInput'
      const refName = type === "contract" ? "fileInput" : "settlementFileInput";
      const fileInput = this.$refs[refName];
      if (fileInput) {
        fileInput.click();
      }
    },
    // 新增 type 参数，默认 'contract'
    onFileSelect(event, type = "contract") {
      const file = event.target.files[0];
      if (!file) return;

      // 校验文件（复用）
      const validation = this.validateFile(file);
      if (!validation.valid) {
        this.$message.warning(validation.message);
        event.target.value = ""; // 清空输入框
        return;
      }

      event.target.value = ""; // 避免重复选择同一文件不触发change
      // 执行上传（传入类型）
      this.simulateUploadSuccess(file, null, type);
    },

    // ✅ 新增：统一文件校验方法
    validateFile(file) {
      const MAX_SIZE = 100 * 1024 * 1024; // 50MB

      // 检查文件大小
      if (file.size > MAX_SIZE) {
        return {
          valid: false,
          message: "文件大小不能超过 100MB",
        };
      }

      // 检查文件类型（MIME）
      const isPdfByType = file.type === "application/pdf";

      // 检查文件扩展名（防止 MIME 类型被篡改或识别错误）
      const fileName = file.name.toLowerCase();
      const isPdfByExt = fileName.endsWith(".pdf");

      if (!isPdfByType || !isPdfByExt) {
        return {
          valid: false,
          message: "仅支持 PDF 文件",
        };
      }

      return { valid: true };
    },

    // 模拟上传成功
    // 新增 type 参数，默认 'contract'
    async simulateUploadSuccess(file, index, type = "contract") {
      const _this = this;
      try {
        // --------------------------
        // 1. 区分接口：合同用UploadContractApi，结算单用UploadSettlementApi（需后端提供）
        // --------------------------
        const uploadApi =
          type === "contract" ? UploadContractApi : UploadContractApi;
        // 调用接口获取OSS上传凭证（逻辑一致，仅接口不同）
        const apiRes = await uploadApi({
          filename: file.name,
          ...(type === "settlement" && { type: 2 }),
        });
        const res = apiRes.data || apiRes;

        // 2. 校验OSS凭证（逻辑与原代码一致，无修改）
        if (
          !res.host ||
          !res.key ||
          !res.policy ||
          !res.signature ||
          !res.accessid
        ) {
          throw new Error("上传凭证不完整，请重试");
        }
        // 区分签名Key存储：合同用SignKey，结算单用settlementSignKey
        if (type === "contract") {
          this.SignKey = res.key;
        } else {
          this.settlementSignKey = res.key;
        }

        // 3. 构造FormData上传到OSS（逻辑完全一致，无修改）
        const formData = new FormData();
        formData.append("OSSAccessKeyId", res.accessid);
        formData.append("policy", res.policy);
        formData.append("signature", res.signature);
        formData.append("key", res.key);
        formData.append("file", file);
        formData.append("success_action_status", "200");

        // 4. 上传到OSS（逻辑完全一致，无修改）
        const ossResponse = await fetch(`https://${res.host}`, {
          method: "POST",
          body: formData,
        });
        if (!ossResponse.ok) {
          const errorText = await ossResponse.text();
          throw new Error(`OSS 上传失败: ${ossResponse.status} ${errorText}`);
        }

        // --------------------------
        // 5. 区分后端回调接口：合同用UploadctApi，结算单用UploadSettlementctApi（需后端提供）
        // --------------------------
        const finishApi = type === "contract" ? UploadctApi : UploadctApi;
        const finishResponse = await finishApi({
          key: res.key,
          id: this.id, // 复用原有的id（如合同ID/项目ID，需确保后端支持）
          ...(type === "settlement" && { type: 2 }),
        });
        const finishData = finishResponse.data || finishResponse;
        // --------------------------
        // 6. 区分数据更新：合同更新Pdf数组，结算单更新settlementPdf数组
        // --------------------------
        const infoApi = type === "contract" ? InfoApi : InfoApi; // 结算单需后端提供获取列表接口
        infoApi({ id: this.id }).then((res) => {
          if (type == "contract") {
            this.Pdf = res.data.pdf;
            this.currentVersionIndex = 0; // 重置合同版本索引为最新
          } else {
            this.settlementPdf = res.data.invoice; // 假设后端返回结算单列表字段为settlementPdf
            this.settlementVersionIndex = 0; // 重置结算单版本索引为最新
          }
        });
      } catch (error) {
        // 区分错误提示文字
        _this.$message.error(
          `❌ ${type === "contract" ? "合同" : "结算单"}上传失败：${error.message || "未知错误"
          }`
        );
      }
    },

    deleteFile(currentFile, type = "contract") {
      // 强制修正 type 为合法值（只允许 'contract' 或 'settlement'）
      if (!["contract", "settlement"].includes(type)) {
        type = "contract"; // 默认为合同，避免参数错误导致的提示异常
      }

      if (!currentFile) return; // 无选中文件时不执行

      this.$confirm(
        `此操作将永久删除该${type === "contract" ? "合同" : "结算单"
        }，是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          console.log("当前删除类型：", type);
          console.log("当前删除文件数据：", currentFile);

          // 区分删除接口：合同用 CloneApi（你原合同删除接口），结算单需替换为实际接口
          const deleteApi = type === "contract" ? CloneApi : CloneApi;
          console.log(currentFile, 321);
          // 调用删除接口
          deleteApi({
            id: currentFile.id, // 传入当前文件的ID
            ...(type === "settlement" && { type: 2 }),
          })
            .then((res) => {
              if (res.code === 1000) {
                this.$message({
                  type: "success",
                  message: `${type === "contract" ? "合同" : "结算单"
                    }删除成功!`,
                });

                // 根据类型更新对应的数据列表
                const fileList =
                  type === "contract" ? this.Pdf : this.settlementPdf;
                const index = fileList.findIndex(
                  (item) => item.id === currentFile.id
                );

                if (index !== -1) {
                  // 从列表中移除删除的文件
                  if (type === "contract") {
                    this.Pdf.splice(index, 1);
                  } else {
                    this.settlementPdf.splice(index, 1);
                  }

                  // 调整当前版本索引（避免删除后索引越界）
                  const currentIndex =
                    type === "contract"
                      ? this.currentVersionIndex
                      : this.settlementVersionIndex;
                  const newListLength =
                    type === "contract"
                      ? this.Pdf.length
                      : this.settlementPdf.length;

                  if (currentIndex >= newListLength && newListLength > 0) {
                    // 如果删除的是当前显示的版本，切换到最后一个版本
                    if (type === "contract") {
                      this.currentVersionIndex = newListLength - 1;
                    } else {
                      this.settlementVersionIndex = newListLength - 1;
                    }
                  } else if (newListLength === 0) {
                    // 如果列表为空，重置索引为0
                    if (type === "contract") {
                      this.currentVersionIndex = 0;
                    } else {
                      this.settlementVersionIndex = 0;
                    }
                  }
                }
              } else {
                this.$message({ type: "error", message: res.msg });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: `删除失败：${err.message || "网络错误"}`,
              });
            });
        })
        .catch((err) => {
          console.log("删除操作被取消或出错：", err);
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 新增 type 参数，默认 'contract'
    prevVersion(type = "contract") {
      // 根据类型获取列表和索引
      const list = type === "contract" ? this.Pdf : this.settlementPdf;
      if (list.length === 0) return; // 列表为空时不操作（修复原有bug）

      // 根据类型更新索引
      if (type === "contract") {
        this.currentVersionIndex =
          (this.currentVersionIndex - 1 + list.length) % list.length;
      } else {
        this.settlementVersionIndex =
          (this.settlementVersionIndex - 1 + list.length) % list.length;
      }
    },

    // 新增 type 参数，默认 'contract'
    nextVersion(type = "contract") {
      const list = type === "contract" ? this.Pdf : this.settlementPdf;
      if (list.length === 0) return;

      if (type === "contract") {
        this.currentVersionIndex = (this.currentVersionIndex + 1) % list.length;
      } else {
        this.settlementVersionIndex =
          (this.settlementVersionIndex + 1) % list.length;
      }
    },

    reduce() {
      this.searchLabelDialog = false;
    },

    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = "3vh";
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = "10vh";
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = "15vh";
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = "20vh";
      }
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.income_id;
    },
    huaguo(row, column, cell, event) {
      this.selectedId = row.income_id;
    },
    //点击打开弹窗事件
    kanEvt(type) {
      if (type == 1) {
        this.selectedId = "";
      } else if (type == 2) {
        //打开收入管理弹窗详情页
        IncomeApi({
          id: this.selectedId,
        }).then((res) => {
          if (res.code == 1000) {
            this.resData_one = res.data;
            this.$refs.childComponentRef.openDialog(this.resData_one);
            this.dialogVisible = true;
          }
        });
      }
    },

    imgEvt(e) {
      if (this.selectArr.length >= 1 && this.shift === true) {
        let start,
          end = "";
        for (var i = 0; this.images.length > i; i++) {
          if (this.images[i].id === e.id) {
            start = i;
          }
          if (this.images[i].id !== e.id && this.images[i].select === true) {
            end = i;
          }
        }
        if (start || (start == 0 && end)) {
          if (start > end) {
            let temp = "";
            temp = end;
            end = start;
            start = temp;
          } else {
            start++;
          }
          for (var i = 0; this.images.length > i; i++) {
            if (i >= start && i < end) {
              this.images[i].select = true;
            }
          }
        }
      }
      this.images = this.images.map((res) => {
        if (res.id == e.id) {
          if (res.select) {
            res.select = "";
          } else {
            res.select = true;
          }
        }
        return res;
      });
      this.selectArr = this.images.filter((res) => res.select == true);
    },

    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map((res) => res.id);
      return source_ids;
    },
    //空格事件
    handKeyCode(e) {
      e = e || window.event;
      if (this.images.filter((res) => res.select == true).length !== 0) {
        //空格空格事件
        if (e.keyCode == 32) {
          const ids = this.getSourceId(); // 获取res数组
          InfoTwoApi({
            id: ids,
          }).then((res) => {
            this.searchLabelDialog = true;
            this.infoArr = res.data.images;
          });
          e.preventDefault();
        }
      }
      //键盘0清除选择
      if (e.keyCode == 48 || e.keyCode == 96 || e.keyCode == 67) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          return;
        }
        this.imgArr = this.imgArr.map((res) => {
          res.select = false;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
      }
      //键盘A事件（全选）
      if (e.keyCode == 65) {
        this.imgArr = this.imgArr.map((res) => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
      }
    },
    //空格打开弹窗关闭事件
    clearValues() {
      // 清空相关值
      this.infoArr = [];
      this.currentIndex = 0;
    },
    //切换上一页
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    //切换下一页
    nextImage() {
      if (this.currentIndex < this.infoArr.length - 1) {
        this.currentIndex++;
      }
    },
    //删除图片
    deleteImage() {
      var source_ids = this.selectArr.map((res) => res.id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DeleApi({
            id: source_ids,
          }).then((res) => {
            if (res.code == 1000) {
              this.images = this.images.filter(
                (image) => !source_ids.includes(image.id)
              );
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message.error("删除失败 请选中图片!");
            }
          });
        })
        .catch(() => { });
    },
    submitFun() {
      const newRemark = this.DateData[this.DateData.length - 1].remark; // 获取最后一行的remark值
      AddApi({
        id: this.id,
        remark: newRemark,
        type: this.type,
      }).then((res) => {
        if (res.code == 1000) {
          this.dialogTableVisible = false;
          this.remarkEvt(this.type);
        }
      });
    },
    //新增
    handleAdd() {
      const newTableData = {
        username: "",
        create_time: "",
        remark: "",
      };
      this.DateData.push(newTableData);
    },
    remarkEvt(type) {
      this.type = type;
      RemarklistApi({
        id: this.id,
        type: this.type,
      }).then((res) => {
        this.DateData = res.data;
        this.dialogTableVisible = true;
      });
    },

    getTitleText() {
      if (this.type === 1) {
        return "制作内容备注";
      } else if (this.type === 2) {
        return "项目进度备注";
      } else if (this.type === 3) {
        return "回款进度备注";
      } else {
        return "未知类型";
      }
    },
    cleEvt() {
      this.asd = true;
    },
    //选择客户名称 自动出现客户维护
    openEvt_one() {
      for (let i = 0; i < this.customer_box.length; i++) {
        if (this.customer_box[i].id === this.customer) {
          this.value_1 = this.customer_box[i].value_1;
          this.assistant_id = this.customer_box[i].assistant_id;
          break;
        }
      }
      this.asd = true;
    },
    openEvt(index) {
      this.asd = true;
    },

    saveEvt() {
      this.start_time = this.value3 / 1000;
      this.end_time = this.value1 / 1000;
      this.demand_time = this.value2 / 1000;
      const dataList = [];
      let groupIndex = 0;
      if (this.tableDate.every((row) => row.group_id)) {
        // 如果所有行数据的group_id都不为空
        this.tableDate.forEach((row, index) => {
          const combinedData = {
            group_id: row.group_id,
            type_plan: row.type_plan,
            type_birdview: row.type_birdview,
            type_perspective: row.type_perspective,
            type_indoor: row.type_indoor,
            type_vr: row.type_vr,
            type_animation: row.type_animation,
          };
          dataList.push(combinedData);
          groupIndex++;
        });
      } else {
        alert("请输入小组名称");
        // 如果有行数据的group_id为空
        return;
      }
      if (!this.name) {
        alert("请输入项目名称");
        return;
      }

      this.loading = true;
      let data = {
        start_time: this.start_time, //开工时间
        end_time: this.end_time, //实际完工时间
        demand_time: this.demand_time, //要求完工时间
        name: this.name,
        status: this.activeIndex_box,
        contract_amount: this.contract_amount,
        sign_id: this.set_of, //市场签单
        assistant_id: this.assistant_id, //客户维护
        charge_id: this.charge, //项目负责人
        customer_id: this.customer, //客户名称
        refund_remark: this.refund_remark,
        content_remark: this.content_remark,
        progress_remark: this.progress_remark,
        group: dataList,
        currency: this.currency,
        type_plan: this.type_plan,
        type_birdview: this.type_birdview,
        type_perspective: this.type_perspective,
        type_indoor: this.type_indoor,
        type_vr: this.type_vr,
        type_animation: this.type_animation,
        // 将共享的data数组添加到data对象中
        id: this.id,
      };
      if (this.asd == true) {
        EditApi(data).then((res) => {
          if (res.code == 1000) {
            // 保存成功
            this.clickTriggered = false;
            // 显示保存成功的提示信息
            this.asd = false;
            this.$message.success("保存成功" + res.msg);
            if (
              this.areEqual &&
              this.areEqual1 &&
              this.areEqual2 &&
              this.areEqual3 &&
              this.areEqual4 &&
              this.compareIndoor &&
              this.comparePerspective &&
              this.compareBirdview &&
              this.comparePlan &&
              this.compareVR &&
              this.a &&
              this.b
            ) {
              this.$emit("save-success", { success: true, id: this.id });
            } else {
              this.$emit("save-success", { success: false, id: this.id });
            }
          } else {
            // 保存失败
            this.$message.error("保存失败：" + res.msg);
          }
          setTimeout((e) => {
            this.loading = false;
          }, 1000);
        });
      } else if (this.asd == false) {
        alert("没有修改内容");
        this.loading = false;
      }
    },

    addRow() {
      const selectedValues = this.tableDate.map((row) => row.group_id); // 获取已选中的值
      const availableOptions = this.group_box.filter(
        (item) => !selectedValues.includes(item.id)
      ); // 过滤出可选的选项

      const newRow = {
        group_id: "",
        type_plan: "",
        type_birdview: "",
        type_perspective: "",
        type_indoor: "",
        type_vr: "",
        type_animation: "",
      };
      this.tableDate.push(newRow);
      this.selectedValues = selectedValues; // 更新 selectedValues
      
    },
    handleClick(index) {
      this.tableDate.splice(index, 1);
      this.asd = true;
    },
    xiugai() {
      console.log(this.asd,  123);
        this.asd = true 
    },
    // 打开弹窗
    openDialog(resData, e) {
      this.userRole = localStorage.getItem("role");
      this.dialogVisible = true;
      this.backendValue = resData;

      if (!resData) {
        this.refund_remark = null;
        this.progress_remark = null;
        this.refund_remark = null;
        this.contract_amount = null;
        this.content_remark = null;
        this.assistant_id = null;
        this.value_1 = null;
        this.backed_days = null;
        this.charge = null;
        this.set_of = null;
        this.customer = null;
        this.name = null;
        this.currency = null;
        this.sign_id = null;
        this.status = null;
        this.value3 = null;
        this.value2 = null;
        this.value1 = null;
        this.type_animation = null;
        this.id = null;
        this.type_plan = null;
        this.type_birdview = null;
        this.type_indoor = null;
        this.type_perspective = null;
        this.type_total = null;
        this.type_vr = null;
        this.tableDate = [];
        this.asd = false;
        this.amountEvt = "";
        this.activeIndex_box = 1;
        this.backedinfoDtata = [];

        if (e === 1) {
          this.activeTab = "tab5";
        } else if (e === 2) {
          this.activeTab = "tab6";
        } else {
          this.activeTab = "tab1";
        }
        return;
      }

      this.content_remark = resData.content_remark;
      this.progress_remark = resData.progress_remark;
      this.refund_remark = resData.refund_remark;
      this.assistant_id = resData.project.assistant_id;
      this.value_1 = resData.project.value_1;
      this.backed_days = resData.project.backed_days;
      this.charge = resData.project.charge_id;
      this.set_of = resData.project.sign_id;
      this.customer = resData.project.customer_id;

      this.name = resData.project.name;
      this.contract_amount = resData.project.contract_amount;
      this.currency = resData.project.currency;
      this.sign_id = resData.project.sign_id;
      this.id = resData.project.id;
      this.activeIndex_box = resData.project.status;

      this.value3 = resData.project.start_time * 1000;
      this.value2 = resData.project.demand_time * 1000;
      this.value1 = resData.project.end_time * 1000;

      this.type_animation = resData.project.type_animation;

      this.type_plan = resData.project.type_plan;
      this.type_birdview = resData.project.type_birdview;
      this.type_indoor = resData.project.type_indoor;
      this.type_perspective = resData.project.type_perspective;
      this.type_vr = resData.project.type_vr;

      this.type_total = resData.project.type_total;
      this.images = resData.images;
      this.is_success = resData.is_success;
      this.backed_days = resData.project.backed_days;

      this.backedinfoDtata = resData.backedinfo;
      this.tableDate = resData.group;
      //合计总数
      this.total_box =
        parseFloat(this.type_plan) +
        parseFloat(this.type_birdview) +
        parseFloat(this.type_indoor) +
        parseFloat(this.type_perspective) +
        parseFloat(this.type_vr);
      this.amountEvt = this.total_box.toFixed(2).toString();
      console.log(this.amountEvt, "21312");
      console.log(this.total_box, "111");

      const groupType_total = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_total),
          0
        )
      );
      const groupType_animation = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_animation),
          0
        )
      );
      const roundedGroupType_total = groupType_total.toFixed(2); // 假设你想要四舍五入到最接近的整数
      if (roundedGroupType_total == this.amountEvt) {
        this.a = true;
      } else {
        this.a = false;
      }
      if (this.type_animation == groupType_animation) {
        this.b = true;
      } else {
        this.b = false;
      }

      // 将页面上获取的各个参数值转换为数字类型
      const groupTypePlanTotal = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_plan),
          0
        )
      );
      const groupTypeBirdviewTotal = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_birdview),
          0
        )
      );
      const groupTypeIndoorTotal = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_indoor),
          0
        )
      );
      const groupTypePerspectiveTotal = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_perspective),
          0
        )
      );
      const groupTypeVRTotal = parseFloat(
        resData.group.reduce(
          (total, item) => total + parseFloat(item.type_vr),
          0
        )
      );

      // 获取resData.project中对应的参数值并转换为数字类型
      const projectTypePlan = parseFloat(resData.project.type_plan);
      const projectTypeBirdview = parseFloat(resData.project.type_birdview);
      const projectTypeIndoor = parseFloat(resData.project.type_indoor);
      const projectTypePerspective = parseFloat(
        resData.project.type_perspective
      );
      const projectTypeVR = parseFloat(resData.project.type_vr);

      this.isAllZero =
        projectTypePlan == 0 &&
        projectTypeBirdview == 0 &&
        projectTypeIndoor == 0 &&
        projectTypePerspective == 0 &&
        projectTypeVR == 0;

      // 逐一比较这些参数值
      // 比较groupTypePlanTotal和projectTypePlan
      this.comparePlan = groupTypePlanTotal === projectTypePlan;

      // 比较groupTypeBirdviewTotal和projectTypeBirdview
      this.compareBirdview = groupTypeBirdviewTotal === projectTypeBirdview;

      // 比较groupTypePerspectiveTotal和projectTypePerspective
      this.comparePerspective =
        groupTypePerspectiveTotal === projectTypePerspective;

      // 比较groupTypeIndoorTotal和projectTypeIndoor
      this.compareIndoor = groupTypeIndoorTotal === projectTypeIndoor;

      // 比较groupTypeVRTotal和projectTypeVR
      this.compareVR = groupTypeVRTotal === projectTypeVR;
      this.Pdf = resData.pdf || [];
      this.settlementPdf = resData.invoice || []; // 结算单也加上兜底，避免同问题
      this.asd = false;
      if (e === 1) {
        this.activeTab = "tab5";
      } else if (e === 2) {
        this.activeTab = "tab6";
      } else {
        this.activeTab = "tab1";
      }

      this.areEqual = parseInt(groupTypePlanTotal) == parseInt(projectTypePlan);
      this.areEqual1 =
        parseInt(groupTypeBirdviewTotal) == parseInt(projectTypeBirdview);
      this.areEqual2 =
        parseInt(groupTypePerspectiveTotal) ===
        parseInt(projectTypePerspective);
      this.areEqual3 =
        parseInt(groupTypeIndoorTotal) == parseInt(projectTypeIndoor);
      this.areEqual4 = parseInt(groupTypeVRTotal) == parseInt(projectTypeVR);
    },
    setActive(index) {
      this.activeIndex_box = index;
      if (this.activeIndex_box == 1) {
        this.value1 = "";
      } else if (this.activeIndex_box == 2) {
        this.value1 = "";
      } else if (this.activeIndex_box == 3) {
        var date = new Date();
        var beijingTime = new Date(
          date.getTime() + (date.getTimezoneOffset() + 480) * 60000
        );
        var beijingTimestamp = beijingTime.getTime();
        this.value1 = beijingTimestamp;
      }
      this.asd = true;
    },
    showTab(tab) {
      this.activeTab = tab;
      const contentElement = document.getElementById(tab + "Content");
      const containerElement = document.getElementById("container"); // 替换为你的容器元素的ID

      // const contentTop = contentElement.offsetTop;
      // if (tab === 'tab3') {
      //   containerElement.scrollTop = contentTop - 60; // 将内容置顶50px的位置
      // } else {
      //   containerElement.scrollTop = contentTop;
      // }
    },

    handleClickEvt() {
      // this.dialogContent = '点击事件已触发';
      this.clickTriggered = true;
    },
    calculateTotal() {
      console.log(1233123);
      const typePlan = parseFloat(this.type_plan) || 0;
      const birdview = parseFloat(this.type_birdview) || 0;
      const perspective = parseFloat(this.type_perspective) || 0;
      const indoor = parseFloat(this.type_indoor) || 0;
      const vr = parseFloat(this.type_vr) || 0;
      this.total_box = typePlan + birdview + perspective + indoor + vr;
      // 强制转为两位小数的字符串（如 6 → "6.00"）
      this.amountEvt = this.formatNumber(this.total_box).toString();
      this.asd = true;
    },
    amountTotal(row) {
      let _this = this;
      // 1. 重新计算子行总和（避免row.type_total缓存问题）
      const typePlan = Number(row.type_plan) || 0;
      const birdview_box = Number(row.type_birdview) || 0;
      const perspective_box = Number(row.type_perspective) || 0;
      const indoor_box = Number(row.type_indoor) || 0;
      const vr_box = Number(row.type_vr) || 0;
      const total_one =
        typePlan + birdview_box + perspective_box + indoor_box + vr_box;
      row.type_total = total_one.toString(); // 重新赋值子行总和

      // 2. 强制统一精度后对比
      const rowTotal = this.formatNumber(row.type_total); // 子行总和转 6.00
      const amountTotal = this.formatNumber(this.amountEvt); // 合计转 6.00
      console.log("rowTotal:", rowTotal); // 打印子行总和
      console.log("amountTotal:", amountTotal); // 打印合计
      // 此时一定是 true this.isTotalEqual = rowTotal === amountTotal;

      // 3. 手动触发响应式更新（解决Vue检测不到的问题）
      this.$nextTick(() => {
        this.asd = true
        this.$forceUpdate(); // Vue2 强制更新视图
      });

      // 4. 原字段对比逻辑（保留）
      const calculateTypePlan = Number(this.type_plan) || 0;
      const calculateBirdview = Number(this.type_birdview) || 0;
      const calculatePerspective = Number(this.type_perspective) || 0;
      const calculateIndoor = Number(this.type_indoor) || 0;
      const calculateVr = Number(this.type_vr) || 0;
      this.areEqual = Number(typePlan) == Number(calculateTypePlan);
      this.areEqual1 = Number(birdview_box) == Number(calculateBirdview);
      this.areEqual2 = Number(perspective_box) === Number(calculatePerspective);
      this.areEqual3 = Number(indoor_box) == Number(calculateIndoor);
      this.areEqual4 = Number(vr_box) == Number(calculateVr);

      return (
        this.areEqual &&
        this.areEqual1 &&
        this.areEqual2 &&
        this.areEqual3 &&
        this.areEqual4
      );
    },
    // 组件的 methods 中
    formatNumber(num) {
      // 彻底兜底：空值/字符串/非数字 → 0，再转两位小数的数字
      const numVal = Number(num);
      const fixedNum = isNaN(numVal) ? 0 : numVal.toFixed(2);
      return Number(fixedNum); // 最终返回数字（如 6 → 6.00，6.00 → 6.00）
    },
    handleClose() {
      // 清空所有数据
      this.clearContent();
      // 清空PDF相关数据
      this.Pdf = [];
      this.settlementPdf = [];
      this.currentPdf = null;
      this.currentSettlementPdf = null;
      this.currentVersionIndex = 0;
      this.settlementVersionIndex = 0;
      // 关闭对话框
      this.dialogVisible = false;
    },
    clearContent(scope) {
      // 清空表格数据
      this.tableDate = [];
      // 清空图片和文件数据
      this.images = [];
      this.selectArr = [];
      this.infoArr = [];
      // 清空回款信息数据
      this.backedinfoDtata = [];
      // 清空表单数据
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.start_time = "";
      this.end_time = "";
      this.demand_time = "";
      this.contract_amount = "";
      this.set_of = "";
      this.assistant_id = "";
      this.charge = "";
      this.customer = "";
      this.currency = 4;
      this.name = "";
      this.sign = "";
      this.charge = "";
      this.assistant_id = "";
      this.group = "";
      this.value = "";
      // 清空类型数据
      this.type_plan = "";
      this.type_birdview = "";
      this.type_perspective = "";
      this.type_indoor = "";
      this.type_vr = "";
      this.type_animation = "";
      this.amountEvt = "";
      // 清空备注数据
      this.refund_remark = "";
      this.content_remark = "";
      this.progress_remark = "";
      // 清空状态和标志
      this.activeTab = "tab1";
      this.activeIndex_box = 1;
      this.clickTriggered = false;
      this.showError = false;
      this.uploadVisible = false;
      this.selectedValues = [];
      this.dialogTableVisible = false;
      this.searchLabelDialog = false;
      this.currentIndex = 0;
      this.selectedId = null;
      // 清空比较标志
      this.areEqual4 = true;
      this.areEqual3 = true;
      this.areEqual2 = true;
      this.areEqual1 = true;
      this.areEqual = true;
      this.comparePlan = null;
      this.compareBirdview = null;
      this.compareIndoor = null;
      this.comparePerspective = null;
      this.compareVR = null;
      this.a = false;
      this.b = false;
      this.isAllZero = false;
    },
    deleteEvt() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelApi({
            id: this.id,
          }).then((res) => {
            if (res.code == 1000) {
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              alert(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    checkInput() {
      this.asd = true;
      //正则处理 修改数值后可以输入小数点 之前不行
      this.contract_amount = this.contract_amount
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
    },
    checkInput_one() {
      this.asd = true;
    },
    nextFocus(event, index, row) {
      let inputDoms = Array.from(
        document.querySelectorAll(".niaokan .el-input__inner")
      );
      this.inputDoms = inputDoms;

      if (event.keyCode === 13) {
        // 如果按下的是回车键
        const currentIndex = inputDoms.indexOf(event.target); // 找到当前输入框的位置
        const nextIndex = (currentIndex + 1) % inputDoms.length; // 将位置加1并取余
        if (event.target.value.trim() !== "") {
          // 检查当前输入框的值是否为空
          this.inputDoms[nextIndex].focus(); // 直接使用 nextIndex
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.el-dialog {
  background: #f00 !important;
  overflow: hidden;
}

.whole {
  width: 1490px;
  height: 880px;
  display: flex;
}

.banner {
  width: 1120px;
  margin-left: 380px;
  height: 870px;
  overflow: hidden;
  padding-right: 7px;
}

/* 设置滚动条宽度 */
.banner::-webkit-scrollbar {
  width: 5px;
  /* 调整滚动条宽度 */
}

.banner {
  /* 确保元素可以滚动 */
  overflow-y: scroll;
  /* 或者 overflow-y: auto; 根据需要 */
  -ms-overflow-style: none;
  /* IE 和 Edge */
  scrollbar-width: none;
  /* Firefox */
}

.banner::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* 设置滚动条的轨道背景色 */
.banner::-webkit-scrollbar-track {}

/* 设置滚动条手柄（拖动条）颜色 */
.banner::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 20px;
  /* 添加圆角 */
}

.banner::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

//图量安排
.arrangement {
  width: 100%;
  height: 825px;
  margin-top: 32px;
  display: inline-block;
  background: #fff;
  border-radius: 5px;
}

//回款明细
.Payment {
  width: 100%;
  height: 795px;
  margin-top: 32px;
  display: inline-block;
  background: #fff;
  border-radius: 5px;

  /deep/ .el-table--fit {
    margin-top: 0px !important;
  }
}

//成图全部图片
.Mapping_quantity {
  width: 100%;
  margin-top: 10px;
  background: #fff;
  position: relative;
  border-radius: 5px;
  min-height: 795px;
}

.stateE {
  display: flex;
  width: 280px;
  height: 30px;
  padding: 2px;
  justify-content: space-around;
  // align-items: flex-start;
  gap: 6px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d9d9d9;
  margin-left: 65px;
  margin-top: 10px;

  div {
    display: flex;
    width: 88px;
    height: 26px;
    padding: 6px 10px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 3px;
    font-size: 12px;
    color: #958e8e;
    cursor: pointer;
    // box-shadow: 0px 0.2px 4px 0.1px rgba(0, 0, 0, 0.25);
  }

  .active {
    background-color: white;
  }

  .gray {
    background-color: gray;
  }
}

.Completion_status {
  height: 340px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;

  /deep/ .el-input__inner {
    display: flex;
    // width: 280px;
    align-items: center;
    border-radius: 5px;
    border: 0.5px solid #d9d9d9;
    height: 30px;
  }
}

/deep/ .el-input--mini .el-input__inner {
  height: 30px;
}

/deep/ .el-form-item__label {
  padding: 0px;
  font-size: 12px;
  color: #333;
}

/deep/ .el-input {
  width: 280px;
  margin-left: 7px;
}

.mins {
  /deep/ .el-input--suffix {
    width: 89px !important;
    margin-left: 55px;
  }
}

.maxs {
  width: 188px !important;
}

.text_box {
  width: 282px;
  height: 85px;
  border-radius: 5px;
  border: 0.5px solid #d9d9d9;
  outline: none;
  margin-left: 6px;
}

/deep/ .el-form-item {
  margin-bottom: 10px !important;
}

.text_one {
  /deep/ .el-form-item__content {
    margin-bottom: -10px;
  }
}

/deep/ .el-dialog__header {
  background: #d9d9d9;
}

/deep/ .el-dialog__body {
  background: #d9d9d9;
}

//右侧图量样式
.tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  margin-top: 10px;

  span {
    cursor: pointer;
    height: 24px;
    padding: 4px 10px;
    font-size: 12px;
  }
}

.tabs span {
  border-radius: 3px;
}

.tabs span.active {
  background-color: #3383ea;
  color: #fff;
}

.tab-content {
  display: none;
  // padding: 20px;
}

.tab-content.active {
  display: block;
}

//右侧样式
.offside {
  height: 24px;
  display: flex;
  justify-content: space-between;
  position: fixed;
  z-index: 111;
  background: #d9d9d9;
  width: 1110px;
  padding-bottom: 32px;
}

// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;
  cursor: pointer;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 23px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383ea;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 23px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

.upload-btn {
  cursor: pointer;
  padding: 5px 20px;
  background-color: #9c9c9c;
  color: #fff;
  border-radius: 5px;
  display: inline-block;
}

/* 当鼠标悬停在这个元素上时，改变背景颜色 */
.upload-btn:hover {
  background-color: #3383ea;
}

/deep/ .el-table--fit {
  margin-top: -40px !important;
  border-radius: 5px;
}

/deep/ .el-table__body-wrapper {
  overflow: hidden !important;
}

/deep/ .el-table .el-table__cell {
  height: 30px !important;
  padding: 0px !important;
}

/deep/ .el-table th.el-table__cell>.cell:nth-child(1) {
  margin-top: 20.5px;
}

/deep/ .el-table th.el-table__cell {
  background: #fff;
}

/deep/ .el-table__header-wrapper {
  background: #fff !important;
}

//成图
.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 10px;
}

.container_one {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.mapping {
  width: 264px;
  height: 200px;
  background: #f3f3f3;
  margin-top: 20px;
  margin-bottom: 17px;
  display: flex;
  flex-direction: column;
  margin: 20px 3px;

  img {
    width: 100%;
    min-height: 190px;
    display: block;
    object-fit: contain;
    cursor: pointer;
  }
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.amount_to {
  position: relative;
  top: 55px;
  z-index: 1;
  width: 100%;
  height: 50px;
  display: flex;
  padding: 5px;

  div {
    width: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div:nth-child(1) {
    margin-left: 10px;
  }

  div:nth-child(2) {
    margin-left: 20px;
    outline: none;
    border: none;
  }

  div:nth-child(3) {
    outline: none;
    border: none;
  }

  div:nth-child(4) {
    outline: none;
    border: none;
  }

  div:nth-child(5) {
    margin-left: 10px;
    outline: none;
    border: none;
  }

  div:nth-child(6) {
    outline: none;
    border: none;
  }

  div:nth-child(7) {
    outline: none;
    border: none;
  }

  div:nth-child(8) {
    margin-left: -2px;
  }
}

.my-table {
  /deep/ .el-table__body-wrapper {
    /* 自定义样式 */
    margin-top: 50px !important;
    overflow-y: hidden !important;
    /* 更多样式... */
  }
}

.signEvt {
  height: 30px !important;

  /deep/ .el-input {
    width: 110px !important;
  }

  /deep/ .el-input__inner {
    width: 110px !important;
    height: 30px !important;
  }

  /deep/ .el-input__icon {
    line-height: 30px !important;
  }
}

.niaokan {
  width: 50px;
  outline: none;
  height: 30px;
  text-align: center;
  border: none;
}

.niaokan /deep/ .el-input__inner {
  height: 30px !important;
  padding: 0 5px !important;
  text-align: center;
}

.amount {
  width: 40px;
  outline: none;
  border: none;
  text-align: center;
}

.amount:hover {
  border: 1px solid #d1d1d1;
}

.name_oe /deep/ .el-select-dropdown {
  max-height: 400px !important;
  /* 设置下拉框的最大高度 */
  display: block;
}

.min_one {
  cursor: pointer;
  padding: 5px 20px;
  background-color: #3383ea;
  color: #fff;
  border-radius: 5px;
  top: 10px;
  position: absolute;
  left: 11px;
}

/deep/ .el-table__row {
  height: 50px;
}

.Add_list {
  /deep/ .el-input__inner {
    border: none;
  }
}

.select {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 860px;
  width: 300px;
  opacity: 0;
}

.prev-button:hover {
  cursor: url("../images/left.png"), auto;
}

.next-button {
  position: absolute;
  right: 0;
  top: 0%;
  height: 860px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url("../images/right.png"), auto;
}

.searchLabel .el-dialog__header {
  display: none !important;
}

/deep/ .gray-text .el-input__inner {
  color: #e8e5e5 !important;
}

/* 默认情况下删除按钮透明 */
.mapping .clones {
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 11px;
  width: 100%;
  text-align: right;
  cursor: pointer;
  margin-top: 15px;
}

/* 当鼠标悬停在父元素上时显示删除按钮 */
.mapping:hover .clones {
  opacity: 1;
}

.shangchuan:hover .img_e {
  transform: scale(1.5);
}

.img_e {
  display: inline-block;
  /* 确保scale能正确作用于元素 */
  transition: transform 0.3s ease;
  /* 添加过渡效果使变化更平滑 */
  cursor: pointer;
}

.mapping:nth-of-type(-n+4) {
  margin-top: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/pop_up.vue